var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "pageBox",
        },
        [
          _c(
            "div",
            { staticClass: "breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v("首页"),
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("工单信息")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pageSerch" },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "cardTitle" }, [
                        _vm._v("工单信息"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("投诉原因"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.detail.complainTypeName)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "title" }, [_vm._v("投诉人")]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.detail.complainantName))]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("投诉人联系方式"),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(_vm._s(_vm.detail.complainantPhone)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("被投诉人"),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.detail.respondentName))]),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("被投诉人联系方式"),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.detail.respondentPhone))]),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "50%" } }, [
                        _c("div", { staticClass: "dis" }, [
                          _c(
                            "div",
                            {
                              staticClass: "title",
                              staticStyle: { "margin-bottom": "0" },
                            },
                            [_vm._v("关联订单")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "blue",
                                cursor: "pointer",
                                "font-size": "16px",
                                "margin-left": "20px",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.goDetail1({ id: _vm.detail.jobId })
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                查看订单详情\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dis" }, [
                          _c(
                            "div",
                            {
                              staticClass: "title",
                              staticStyle: { "margin-bottom": "0" },
                            },
                            [_vm._v("投诉时间")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "20px" } },
                            [_vm._v(_vm._s(_vm.detail.submitAt))]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dis" }, [
                          _c(
                            "div",
                            {
                              staticClass: "title",
                              staticStyle: {
                                "margin-bottom": "0",
                                flex: "none",
                              },
                            },
                            [
                              _vm._v(
                                "\n                附件证据\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.detail.complainantAttachmentList &&
                          _vm.detail.complainantAttachmentList.length
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-left": "20px",
                                    display: "flex",
                                    "flex-wrap": "wrap",
                                  },
                                },
                                _vm._l(
                                  _vm.detail.complainantAttachmentList,
                                  function (item, index) {
                                    return _c("el-image", {
                                      key: index,
                                      staticStyle: {
                                        width: "150px",
                                        height: "50px",
                                        "margin-right": "10px",
                                        "margin-bottom": "10px",
                                      },
                                      attrs: {
                                        src: item,
                                        alt: "",
                                        "preview-src-list": [item],
                                      },
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "50%" } }, [
                        _c("div", { staticClass: "dis" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("工单状态"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: {
                                    disabled:
                                      _vm.detail.status == 2 ? true : false,
                                    placeholder: "请选择状态",
                                  },
                                  model: {
                                    value: _vm.status1,
                                    callback: function ($$v) {
                                      _vm.status1 = $$v
                                    },
                                    expression: "status1",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "待处理", value: "0" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "处理中", value: "1" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "已处理", value: "2" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dis" }, [
                          _c(
                            "div",
                            {
                              staticClass: "title",
                              staticStyle: { flex: "none" },
                            },
                            [_vm._v("上传附件")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                              },
                            },
                            [
                              _vm._l(_vm.imgList, function (value, index) {
                                return _vm.imgList.length
                                  ? _c(
                                      "div",
                                      {
                                        key: index,
                                        staticStyle: {
                                          width: "100px",
                                          height: "100px",
                                          position: "relative",
                                          "margin-right": "10px",
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _vm.detail.status != 2
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-circle-close",
                                              staticStyle: {
                                                position: "absolute",
                                                top: "-5px",
                                                right: "-5px",
                                                cursor: "pointer",
                                                "font-size": "20px",
                                                "z-index": "2",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemove(index)
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("el-image", {
                                          staticClass: "avatar",
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%",
                                          },
                                          attrs: {
                                            src: value,
                                            "preview-src-list": [value],
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }),
                              _vm._v(" "),
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    accept: "image/*",
                                    action: _vm.uploadUrl,
                                    headers: _vm.deader,
                                    multiple: true,
                                    "show-file-list": false,
                                    "on-success": _vm.handleAvatarSuccess,
                                    "before-upload": _vm.beforeAvatarUpload,
                                    disabled:
                                      _vm.detail.status == 2 ? true : false,
                                  },
                                },
                                [
                                  _vm.detail.status != 2
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                        staticStyle: { "margin-top": "50px" },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dis",
                            staticStyle: { "margin-top": "20px" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "title",
                                staticStyle: { "margin-left": "30px" },
                              },
                              [_vm._v("备注")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _c("el-input", {
                                  staticStyle: { "min-width": "400px" },
                                  attrs: {
                                    disabled:
                                      _vm.detail.status == 2 ? true : false,
                                    type: "textarea",
                                    rows: 4,
                                    maxlength: "500",
                                    placeholder: "请输入备注信息字数500字之内",
                                  },
                                  model: {
                                    value: _vm.remark,
                                    callback: function ($$v) {
                                      _vm.remark = $$v
                                    },
                                    expression: "remark",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", { staticStyle: { width: "50%" } }, [
                        _c("div", { staticClass: "dis" }, [
                          _c(
                            "div",
                            {
                              staticClass: "title",
                              staticStyle: { "margin-bottom": "0" },
                            },
                            [_vm._v("保安待结算金额")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "20px" } },
                            [
                              _vm._v(
                                "\n                ￥" +
                                  _vm._s(_vm.detail.securityPendingAmount) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dis" }, [
                          _c(
                            "div",
                            {
                              staticClass: "title",
                              staticStyle: { "margin-bottom": "0" },
                            },
                            [_vm._v("确认结算金额")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "margin-left": "20px" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled:
                                    _vm.detail.status == 2 ? true : false,
                                  type: "number",
                                  maxlength: "7",
                                  placeholder: "请输入结算金额",
                                },
                                model: {
                                  value: _vm.money,
                                  callback: function ($$v) {
                                    _vm.money = $$v
                                  },
                                  expression: "money",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "50%" } }, [
                        _c("div", { staticClass: "dis" }, [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("异常记录"),
                          ]),
                          _vm._v(" "),
                          _vm.detail.abnormalRecords != ""
                            ? _c(
                                "div",
                                { staticStyle: { "margin-left": "20px" } },
                                _vm._l(
                                  _vm.detail.abnormalRecords,
                                  function (item, index) {
                                    return _c("div", { key: index }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item) +
                                          "\n                "
                                      ),
                                    ])
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.detail.status != 2
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            "text-align": "center",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-top": "20px" },
                              attrs: { type: "primary" },
                              on: { click: _vm.confrim },
                            },
                            [_vm._v("提交工单")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }